<template>
  <div class="table-content">
    <div class="header">
      <div
        class="item"
        style="flex: 0.7;"
      >
        分数线
      </div>
      <div class="item">
        2022年
      </div>
      <div class="item">
        2021年
      </div>
    </div>
    <div class="wrap">
      <div
        class="item"
        style="flex: 0.7;"
      >
        学院
      </div>
      <div
        class="item"
        style="flex: 2;"
        @click="show2021 = false;show2022 =false;academyShow = !academyShow"
      >
        {{academys[academysIndex].code?`(${academys[academysIndex].code})`:''}}{{academys[academysIndex].name}}

      </div>
    </div>
    <div class="columns">
      <div
        class="column"
        style="border-right: solid #EAEAEA 1px;flex: 0.7;"
      >
        <div
          class="item"
          v-for="(item,index) in subjects"
          :key="index"
        >
          {{item}}
        </div>
      </div>
      <div class="column">
        <div
          class="item"
          @click="show2022 = !show2022;show2021 =false;academyShow =false"
        >
          <template v-if="list2022.length">
            <span>
              {{list2022[index2022].direction_name}}
            </span>

          </template>
          <template v-else>
            <span>
              不区分研究方向
            </span>
          </template>
        </div>
        <div class="item">
          {{list2022.length&&list2022[index2022]&&list2022[index2022].score_total&&list2022[index2022].score_total!='-'?`${list2022[index2022].score_total}分`:'-'}}
        </div>
        <div class="item">
          {{list2022.length&&list2022[index2022]&&list2022[index2022].score_politics&&list2022[index2022].score_politics!='-'?`${list2022[index2022].score_politics}分`:'-'}}
        </div>
        <div class="item">
          {{list2022.length&&list2022[index2022]&&list2022[index2022].score_language&&list2022[index2022].score_language!='-'?`${list2022[index2022].score_language}分`:'-'}}
        </div>
        <div class="item">
          {{list2022.length&&list2022[index2022]&&list2022[index2022].score_business_1&&list2022[index2022].score_business_1!='-'?`${list2022[index2022].score_business_1}分`:'-'}}
        </div>
        <div class="item">
          {{list2022.length&&list2022[index2022]&&list2022[index2022].score_business_2&&list2022[index2022].score_business_2!='-'?`${list2022[index2022].score_business_2}分`:'-'}}
        </div>
      </div>
      <div
        class="column"
        style="border-right: solid #EAEAEA 1px;"
      >
        <div
          class="item"
          @click="show2021 = !show2021;show2022 =false;academyShow =false"
        >
          <template v-if="list2021.length">
            <span>
              {{list2021[index2021].direction_name}}
            </span>

          </template>
          <template v-else>
            <span>
              不区分研究方向
            </span>
          </template>
        </div>
        <div class="item">
          {{list2021.length&&list2021[index2021]&&list2021[index2021].score_total&&list2021[index2021].score_total!='-'?`${list2021[index2021].score_total}分`:'-'}}
        </div>

        <div class="item">
          {{list2021.length&&list2021[index2021]&&list2021[index2021].score_politics&&list2021[index2021].score_politics!='-'?`${list2021[index2021].score_politics}分`:'-'}}
        </div>
        <div class="item">
          {{list2021.length&&list2021[index2021]&&list2021[index2021].score_language&&list2021[index2021].score_language!='-'?`${list2021[index2021].score_language}分`:'-'}}
        </div>
        <div class="item">
          {{list2021.length&&list2021[index2021]&&list2021[index2021].score_business_1&&list2021[index2021].score_business_1!='-'?`${list2021[index2021].score_business_1}分`:'-'}}
        </div>
        <div class="item">
          {{list2021.length&&list2021[index2021]&&list2021[index2021].score_business_2&&list2021[index2021].score_business_2!='-'?`${list2021[index2021].score_business_2}分`:'-'}}
        </div>
      </div>

    </div>
    <div
      class="dropdown-content"
      v-if="show2021"
    >
      <div
        class="item"
        v-for="(item,index) in list2021"
        :key="index"
        @click="changeIndex(item,'2021')"
      >
        {{item.direction_name}}
      </div>
    </div>
    <div
      class="dropdown-content other"
      v-if="show2022"
    >
      <div
        class="item"
        v-for="(item,index) in list2022"
        :key="index"
        @click="changeIndex(item,'2022')"
      >
        {{item.direction_name}}
      </div>
    </div>
    <div
      class="dropdown-content academy"
      v-if="academyShow"
    >
      <div
        class="item"
        v-for="(item,index) in academys"
        :key="index"
        @click="changeAcademy(item,index)"
      >
        {{item.code?`(${item.code})`:''}}{{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreLineTable",
  data() {
    return {
      subjects: [
        '方向',
        '总分',
        '政治/综合',
        '外语',
        '业务课一',
        '业务课二',
      ],
      list2021: [],
      list2022: [],
      index2021: 0,
      index2022: 0,
      show2021: false,
      show2022: false,
      academys: [],
      academysIndex: 0,
      academyShow: false,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    data(val) {
      if (val) {
        this.academys = val.map(v => {
          return {
            code: v.academy_code,
            name: v.academy_name,
          }
        })
        let res = new Map()
        this.academys = this.academys.filter((v) => !res.has(v.code) && res.set(v.code, 1));
        this.changeAcademy(this.academys[this.academysIndex], this.academysIndex)
      }
    }
  },
  mounted() {

  },
  methods: {
    changeIndex(item, year) {
      if (year == '2021') {
        let ind = this.list2021.findIndex(v => {
          return v.id == item.id
        })
        this.index2021 = ind
        this.show2021 = false
      } else if (year == '2022') {
        let ind = this.list2022.findIndex(v => {
          return v.id == item.id
        })
        this.index2022 = ind
        this.show2022 = false
      }
    },
    changeAcademy(item, index) {
      this.academysIndex = index
      let arr = this.data.filter(v => {
        return v.academy_name == item.name
      })
      this.list2022 = arr.filter(v => {

        return v.year == '2022'
      })
      this.list2021 = arr.filter(v => {
        return v.year == '2021'
      })
      this.academyShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.table-content {
  border: solid #eaeaea 1px;
  border-bottom: none;
  border-radius: 4px;
  position: relative;
  width: 100%;

  .header {
    display: flex;
    align-items: center;

    .item {
      height: 43px;
      flex: 1;
      background-color: #ecf2fe;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.9);
      border-right: solid #eaeaea 1px;
    }
  }

  .wrap {
    display: flex;
    align-items: center;

    .item {
      flex: 1;
      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.9);
      border-right: solid #eaeaea 1px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      border-bottom: solid #eaeaea 1px;
    }
  }

  .columns {
    display: flex;

    .column {
      flex: 1;

      .item {
        height: 43px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        border-right: solid #eaeaea 1px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        border-bottom: solid #eaeaea 1px;
      }
    }
  }

  .dropdown-content {
    position: absolute;
    width: 143px;
    top: 130px;
    left: 470px;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0px 1px 4px 0px rgba(208, 208, 208, 0.5);

    .item {
      padding: 16px;
      text-align: center;
      border-bottom: 1px solid #f5f5f5;
    }
  }

  .academy {
    width: 200px;
    left: 340px;
    top: 90px;
  }

  .other {
    left: 226px;
  }
}
</style>
